import { useMutation, useQueryClient } from "@tanstack/react-query";
import { RoleInterface } from "../../../interfaces/roleInterface";
import { ApiResponse } from "../../../interfaces/apiResponseInterface";
import { roleApi } from "../services/role.api";
import {
  errorNotification,
  successNotification,
} from "../../../utils/notification";
import {
  ROLE_MESSAGES_ERROR,
  ROLE_MESSAGES_SUCCESS,
} from "../constants/messages";

export const useSaveRoleMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<ApiResponse<RoleInterface>, Error, RoleInterface>({
    mutationFn: (role) => roleApi.saveRole(role),
    onSuccess: (res, variables) => {
      if (!res.ok) {
        errorNotification(ROLE_MESSAGES_ERROR.SAVE_ERROR);
        return;
      }
      successNotification(ROLE_MESSAGES_SUCCESS.SAVE_SUCCESS);
      queryClient.invalidateQueries({ queryKey: ["roles"] });
      if (variables._id) {
        queryClient.invalidateQueries({
          queryKey: ["role-by-id", variables._id],
        });
      }
    },
    onError: () => {
      errorNotification(ROLE_MESSAGES_ERROR.SAVE_ERROR);
    },
  });
};
